import { Form } from '@/components/forms';
import { getYupSchemaForPassword } from '@/components/forms/password-input/checks/utils';
import { PasswordSection } from '@/components/forms/password-input/component';
import { FormikProps } from 'formik';

export interface ResetPasswordValues {
	password: string;
	repeatPassword: string;
}

// Create a yup schema that checks that the password and repeatPassword are the same
const validationSchema = getYupSchemaForPassword('password', 'repeatPassword');

type FormProps = {
	onSubmit: (values: ResetPasswordValues) => void;
	formRef: React.RefObject<FormikProps<ResetPasswordValues>>;
};

export const ResetPasswordForm = ({ onSubmit, formRef }: FormProps) => {
	const initialValues: ResetPasswordValues = {
		password: '',
		repeatPassword: '',
	};

	return (
		<Form
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			innerRef={formRef}
		>
			{({ getFieldProps, errors, touched }) => (
				<PasswordSection
					passwordProps={{
						label: 'New Password',
						...getFieldProps('password'),
						error: touched.password && errors.password,
						mb: 'md',
					}}
					reenterPasswordProps={{
						label: 'Repeat Password',
						...getFieldProps('repeatPassword'),
						error: touched.repeatPassword && errors.repeatPassword,
						mb: 'md',
					}}
				/>
			)}
		</Form>
	);
};
